import { render, staticRenderFns } from "./policy-record.vue?vue&type=template&id=48dc6d22&scoped=true&"
import script from "./policy-record.vue?vue&type=script&lang=js&"
export * from "./policy-record.vue?vue&type=script&lang=js&"
import style0 from "./policy-record.vue?vue&type=style&index=0&id=48dc6d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc6d22",
  null
  
)

export default component.exports